import { Injectable } from '@angular/core';

import { UserAuthenticationBaseStrategy } from './user-authentication-base-strategy';

@Injectable()
export class EmailOtpStrategy extends UserAuthenticationBaseStrategy {
  // TODO: Implement the relevant functions for OTP authentication with email
}
